import { Route, Routes } from 'react-router-dom'
import MainLayout                     from '../../layouts/MainLayout'
import { DownloadLogTable }           from './DownloadLogTable'

export const DocumentsDownloadLog = (): any => {
    return (
        <MainLayout>
            <div className="max-w-screen-3xl mx-auto w-full">
                <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
                    <Routes>
                        <Route path="/" element={ <DownloadLogTable /> } />
                        <Route path="/:page?" element={ <DownloadLogTable /> } />
                        <Route path="/search/:query" element={ <DownloadLogTable /> } />
                        <Route path="/search/:query/:page?" element={ <DownloadLogTable /> } />
                    </Routes>
                </div>
            </div>
        </MainLayout>
    )
}
